export default __webpack_public_path__ + "static/media/CLICHY (32 sur 176).fde42b20.jpg";